const opinion = () => {
    
    $.fn.raty.defaults.starOn = '/img/front/form/star1.jpg';
    $.fn.raty.defaults.starOff = '/img/front/form/star0.jpg';
    $.fn.raty.defaults.starHalf = '/img/front/form/star05.jpg';

    $('#raty').raty({
        target: '#target',
        //targetType: 'number',
        targetKeep: true,
        score: 0,
        hints: ['Bardzo słaby', 'Słaby', 'Średni', 'Dobry', 'Wspaniały'],
    });
    
    /*
    var opinion_options = {
        beforeSubmit: function(arr, $form, options) {            
            $($form).find('button').html('Wysyłka w trakcie ...');
        },
        success: function(responseText, statusText, xhr, $form) {
            if (responseText != "") {
                var response  = $.parseJSON(responseText);
                
                if(response.success != true){
                    $($form).find('button').html('Wyślij wiadomość');
                } else {     
                    $($form).find('button').html('Dziękujemy :)');
                    $($form).find('input').val('');
                    $($form).find('textarea').val('');
                }
                
            } else {
                $($form).find('button').html('Wyślij wiadomość');
            }
        },
        error: function(responseText, statusText, xhr, $form) {
            console.log(responseText);
            console.log(statusText);
            $($form).find('button').html('Wyślij wiadomość');
        }
    }; 

    // Input names in real form are different, so these rules and masages are not used. Used default labels instead.
    $('#opinion-form').validate({
        rules: {
            firstname: {
                required: true,
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
            },
            message: {
                required: true,
            },
        },
        messages: {
            firstname: {
                required: "Wymagane",
            },
            email: {
                required: "Wymagane",
                email: "Zły format e-mail"
            },
            phone: {
                required: "Wymagane",
            },
            message: {
                required: "Wymagane",
            },
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            error.insertAfter(element).addClass('show');
        },
        highlight: function(element) {
            $(element).parents('.form-group').removeClass('valid').addClass('error');
          },
        unhighlight: function(element) {
            $(element).parents('.form-group').removeClass('error').addClass('valid');
        },
        submitHandler: function(form) {
            //ajax?
            $(form).ajaxSubmit(opinion_options);
        }
    });
    */
 }
 
 module.exports = {
    opinion, 
 };